import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DashboardTotalsHttpService } from './dashboard-totals.http.service';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { AbstractDashboardStore } from './abstract-dashboard.store';
import { AggregationBucket } from '../models/dashboard/aggregation-bucket';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { UserLocalStorageService } from '../../permission/services/user.local.storage.service';
import { User } from '../../auth/models/User';

@Injectable()
export class CompletedUnpaidDashboardStore extends AbstractDashboardStore {

  private completedAndUnpaidLessThan15DaysTotalSubject = new BehaviorSubject<number>(0);
  private completedAndUnpaidBetween15And28DaysTotalSubject = new BehaviorSubject<number>(0);
  private completedAndUnpaidGreaterThan28DaysTotalSubject = new BehaviorSubject<number>(0);

  constructor(
    private dashboardTotalsHttpService: DashboardTotalsHttpService,
    private flashMessagesService: FlashMessagesService,
    private authenticationStore: AuthenticationStore,
    private userLocalStorageService: UserLocalStorageService
  ) {
    super();
  }

  showCard(): Observable<boolean> {
    return this.authenticationStore.user.map((user: User) => {
      const dashboardFilterState = this.userLocalStorageService.getDashboardFilterState(user.email);
      return dashboardFilterState.completedAndUnpaid;
    });
  }

  get completedAndUnpaidTotal(): Observable<number> {
    return Observable.combineLatest(
      this.lessThan15DaysTotal,
      this.between15And28DaysTotal,
      this.greaterThan28DaysTotal
    ).map((latestValues: number[]) =>
      latestValues.reduce((previousTotal: number, currentTotal: number) => previousTotal + currentTotal, 0)
    );
  }

  get lessThan15DaysTotal(): Observable<number> {
    return this.completedAndUnpaidLessThan15DaysTotalSubject.asObservable();
  }

  get between15And28DaysTotal(): Observable<number> {
    return this.completedAndUnpaidBetween15And28DaysTotalSubject.asObservable();
  }

  get greaterThan28DaysTotal(): Observable<number> {
    return this.completedAndUnpaidGreaterThan28DaysTotalSubject.asObservable();
  }

  loadTotalsWithCardStateHandled(): Observable<any> {
    return this.dashboardTotalsHttpService.getCompletedAndUnpaidCounts().catch(error => {
      this.flashMessagesService.error('MESSAGES.ERROR.GET_COMPLETED_UNPAID_TOTALS',
        `Error retrieving completed and unpaid totals: ${error}`);
      return Observable.throw(error);
    }).map(result => {
      result.map(eachBucket => {
        this.setTotal(eachBucket);
      });
      return result;
    });
  }

  setTotal(bucket: AggregationBucket ) {
    if (bucket.key === 'lessThan15DaysTotal') {
      this.completedAndUnpaidLessThan15DaysTotalSubject.next(bucket.totalEvents);
    } else if (bucket.key === 'between15And28DaysTotal') {
      this.completedAndUnpaidBetween15And28DaysTotalSubject.next(bucket.totalEvents);
    } else if (bucket.key === 'greaterThan28DaysTotal') {
      this.completedAndUnpaidGreaterThan28DaysTotalSubject.next(bucket.totalEvents);
    }
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/completed-unpaid-dashboard.store.ts